






























import i18n from "@/i18n";
import Vue from "vue";
// import Chat from "@/components/app/chat";

export default Vue.extend({
  name: "common-footer",
  computed: {
    isMobileBrowser(): boolean {
      const userAgent = navigator.userAgent;
      const mobileRegExp = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i;
      return mobileRegExp.test(userAgent);
    }
  }
  // components: {
  //   Chat
  // }
});
